import { render, staticRenderFns } from "./FormRecaptcha.vue?vue&type=template&id=3f32076b&"
import script from "./FormRecaptcha.vue?vue&type=script&lang=js&"
export * from "./FormRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports